export default __webpack_public_path__ + "static/media/3.47b5658f.jpg";